import React from "react";
import { useForm } from "react-hook-form";

import { stepperFormValidationMapper, i18, trb } from "@utilities";
import { getStep4Validations } from "../../Validations/step4";
import useFormStepControl from "@hooks/useFormStepControl";
import { ActionButtons } from "../../Components";
import { ClientPolitics } from "./groups/ClientPolitics";

const POLITICS_KEYS = [
  "clientPoliticsPosition.0.data.clientPoliticsMinist",
  "clientPoliticsPosition.0.data.clientPoliticsParl",
  "clientPoliticsPosition.0.data.clientPoliticsJutge",
  "clientPoliticsPosition.0.data.clientPoliticsMay",
  "clientPoliticsPosition.0.data.clientPoliticsAudit",
  "clientPoliticsPosition.0.data.clientPoliticsMJoint",
  "clientPoliticsPosition.0.data.clientPoliticsAmb",
  "clientPoliticsPosition.0.data.clientPoliticsJoint",
  "clientPoliticsPosition.0.data.clientPoliticsInternOrg",
  "clientPoliticsPosition.0.data.clientPoliticsPolPart",
  "clientPoliticsPosition.0.data.clientPoliticArmForces",
  "clientPoliticsPosition.0.data.clientPoliticOther",
  "clientPoliticsPosition.0.data.clientPoliticOtherInput",
  "clientPoliticsPosition.0.ClientPoliticsPosList",
  "clientPolitics.0.clientPoliticsList",
  "clientPolitics.0.data.clientPoliticsName",
  "clientPolitics.0.data.clientPoliticsCountry",
  "clientPolitics.0.data.pepInstitution",
  "clientPolitics.0.data.clientPep_Id"
];

const customPoliticsValidation = values => {
  if (
    values.clientProfile[0].data.clientPoliticsMember === 0 ||
    values.clientProfile[0].data.clientPoliticsMember === "0"
  )
    return {};
  const atleastOneFieldChecked = Object.values(
    values?.clientPoliticsPosition?.[0]?.data || {}
  ).filter(v => v).length;

  if (!atleastOneFieldChecked) {
    return {
      clientPoliticsPosition: [
        {
          data: {
            clientPoliticOther: {
              message: trb(i18.Validations.FieldsRequired),
              type: "oneFieldRequired"
            }
          }
        }
      ]
    };
  }
  return {};
};

export const FormStep4 = React.memo(() => {
  const {
    formDraft,
    submitForm,
    isSent,
    handleActionButtonClick,
    submitType,
    validateForm
  } = useFormStepControl();

  const { handleSubmit, control, unregister } = useForm({
    resolver: (values, context) =>
      validateForm(values, context, () => {
        const { errors } = stepperFormValidationMapper(
          values,
          getStep4Validations({
            validatePolitics:
              values.clientProfile[0].data.clientPoliticsMember === 1 ||
              values.clientProfile[0].data.clientPoliticsMember === "1"
          })
        );
        const politicsError = customPoliticsValidation(values);

        return { values, errors: { ...errors, ...politicsError } };
      }),
    mode: "onChange",
    context: {
      submitType
    },
    shouldFocusError: true,
    defaultValues: formDraft.personData
  });

  const onSubmit = data => {
    submitForm(data, submitType);
  };

  const resetOtherField = e => {
    if (e.target.checked) return;
    unregister("clientPoliticsPosition.0.data.clientPoliticOtherInput");
  };

  const resetPoliticsFields = e => {
    if (e.target.value === 1) return;
    unregister(POLITICS_KEYS);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ClientPolitics
          control={control}
          resetOtherField={resetOtherField}
          resetPoliticsFields={resetPoliticsFields}
        />
        <ActionButtons
          isLoading={isSent}
          handlePrevStep={handleActionButtonClick}
          handleNextStep={handleActionButtonClick}
        />
      </form>
    </>
  );
});
